export const handleSubmit = ({ mutation: createGraphicSet, history }) => values => {
  const updatedData = createGraphicSet({
    variables: {
      graphicSetInput: {
        ...values,
        events: undefined,
        layouts:
          values.layouts &&
          values.layouts.map(layout => ({
            ...layout,
            id: undefined,
            assetIdCategoryIds: undefined,
            originalSize: undefined,
            assetIdCodename: undefined,
            format: undefined,
            cron: "* * * *",
            pos: {
              x: parseFloat(layout.pos.x),
              y: parseFloat(layout.pos.y),
            },
            size: {
              x: parseFloat(layout.size.x),
              y: parseFloat(layout.size.y),
            },
            seconds: parseInt(layout.seconds),
            segments: layout.segments.map(segment => ({ ...segment, id: undefined })),
          })),
        customerId: undefined,
      },
      customerId: values.customerId ? values.customerId : null,
    },
  });

  return updatedData
    .then(result => {
      const graphicSet = result.data.createGraphicSet;
      if (graphicSet && graphicSet.id) {
        history.replace(`/graphicset/details/${graphicSet.id}/customerId/${graphicSet.customerId}`);
        //history.push(`/graphicset/details/${graphicSet.id}/customerId/${graphicSet.customerId}`);
      }
    })
    .catch(console.error);
};
